
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetomahabaleshawar() {



    const cardData =
    {
        keyword: 'Pune to Mahabaleshwar Tempo Traveller',
        heading: 'Mauli Cabs: Pune to Mahabaleshwar Tempo Traveller',
        headingDescription: 'Mauli Cabs offers convenient Pune to Mahabaleshwar tempo traveller services, ideal for group getaways, family vacations, or corporate outings. Our fleet of well-maintained tempo travellers is perfect for long journeys, providing ample seating, air conditioning, and a comfortable travel experience. Whether you’re planning a relaxed family trip or an adventurous outing, we ensure that your journey to Mahabaleshwar is smooth and enjoyable. With professional drivers, timely pickups, and transparent pricing with no hidden charges, Mauli Cabs guarantees a hassle-free trip.',

        top: 'Top Places to Visit in Mahabaleshwar  with Mauli Cabs',

"topPlaces": [
    {
        "title": "Mahabaleshwar Temple",
        "description": "The Mahabaleshwar Temple is a historic temple dedicated to Lord Shiva and is one of the prominent pilgrimage sites in the region. The temple’s architecture and surrounding ambiance make it a serene place for worship."
    },
    {
        "title": "Arthur’s Seat",
        "description": "Arthur’s Seat offers a panoramic view of the surrounding valleys and mountains, often referred to as the 'Queen of all points.' It’s a popular spot for photography and sightseeing."
    },
    {
        "title": "Venna Lake",
        "description": "Venna Lake is a serene spot where visitors can enjoy boat rides surrounded by lush greenery. The lake offers a relaxing experience and is one of the most visited tourist attractions in Mahabaleshwar."
    },
    {
        "title": "Pratapgad Fort",
        "description": "Pratapgad Fort is a historic hill fort known for its strategic importance during the Maratha Empire. It offers breathtaking views and a glimpse into the rich history of the region."
    },
    {
        "title": "Mapro Garden",
        "description": "Mapro Garden is a popular attraction in Mahabaleshwar known for its delicious fruit-based products and refreshing strawberry shakes. It’s a great place to relax and enjoy the scenic surroundings."
    },
    {
        "title": "Elephant’s Head Point",
        "description": "Elephant’s Head Point is a famous viewpoint offering stunning views of the surrounding hills and valleys. The rock formation here resembles the head of an elephant, making it a popular landmark."
    },
    {
        "title": "Wilson Point",
        "description": "Wilson Point is the highest point in Mahabaleshwar, offering stunning views of the sunrise and surrounding landscapes. It is a great spot for trekking and nature walks."
    },
    {
        "title": "Lingmala Waterfall",
        "description": "Lingmala Waterfall is one of the most beautiful waterfalls in Mahabaleshwar, surrounded by dense forests. The waterfall cascades down from a height, creating a refreshing atmosphere."
    },
    {
        "title": "Famous Strawberry Farms",
        "description": "Mahabaleshwar is known for its strawberry farms, and visitors can enjoy picking fresh strawberries or simply savoring delicious strawberry-based products like jams, ice creams, and milkshakes."
    },
    {
        "title": "Chinaman's Waterfall",
        "description": "Chinaman’s Waterfall is a beautiful and picturesque waterfall located in a tranquil setting. It is a great spot for nature lovers and photographers looking to capture the beauty of Mahabaleshwar."
    }
],

"services": [
    {
      "name": "Pune to Mahabaleshwar Tempo Traveller",
      "description": "Book a Tempo Traveller for a comfortable and convenient journey from Pune to Mahabaleshwar. Ideal for family and group travel, ensuring a smooth ride."
    },
    {
      "name": "Tempo Traveller from Pune to Mahabaleshwar",
      "description": "Travel from Pune to Mahabaleshwar in a well-maintained Tempo Traveller. Perfect for large groups looking for a hassle-free travel experience."
    },
    {
      "name": "26 Seater Tempo Traveller from Pune to Mahabaleshwar",
      "description": "Rent a 26-seater Tempo Traveller for large groups traveling from Pune to Mahabaleshwar. Spacious and comfortable, designed for long-distance travel."
    },
    {
      "name": "Pune to Panchgani Tempo Traveller",
      "description": "Enjoy a relaxing trip from Pune to Panchgani in a Tempo Traveller. This option is great for group outings, school trips, and corporate tours."
    },
    {
      "name": "Pune to Panchgani 17 Seater Tempo Traveller",
      "description": "Rent a 17-seater Tempo Traveller for a comfortable journey from Pune to Panchgani. Ideal for family gatherings and small group tours."
    },
    {
      "name": "Pune to Mahabaleshwar 17 Seater Tempo Traveller",
      "description": "Travel from Pune to Mahabaleshwar in a 17-seater Tempo Traveller. Perfect for medium-sized groups, providing ample space and comfort."
    },
    {
      "name": "Pune to Mahabaleshwar Mini Bus on Rent",
      "description": "For larger groups, rent a mini bus for your trip from Pune to Mahabaleshwar. Enjoy the convenience of spacious seating and great service."
    },
    {
      "name": "Pune to Mahabaleshwar Travel Package",
      "description": "Book an all-inclusive travel package for your Pune to Mahabaleshwar trip. Enjoy a seamless experience with transportation and accommodation options."
    },
    {
      "name": "Pune to Mahabaleshwar Package 1 Day",
      "description": "A quick one-day tour package for Mahabaleshwar. Perfect for a day trip from Pune, including transportation and sightseeing."
    },
    {
      "name": "Pune to Mahabaleshwar Tour Package 3 Days",
      "description": "A comprehensive 3-day tour package from Pune to Mahabaleshwar, covering transportation, accommodations, and guided sightseeing tours."
    },
    {
      "name": "Pune to Mahabaleshwar Mini Bus Packages",
      "description": "Rent a mini bus for your Pune to Mahabaleshwar trip with tailored packages to suit your group size and travel preferences."
    },
    {
      "name": "Pune to Mahabaleshwar 14, 17, 25, 32 Seater Tempo Traveller",
      "description": "Choose from a variety of Tempo Travellers (14, 17, 25, or 32 seater) for your group travel from Pune to Mahabaleshwar. These vehicles provide comfort and ample seating for your journey."
    }
  ],
  "tableData": [
    ["Pune to Mahabaleshwar Tempo Traveller", "Tempo Traveller from Pune to Mahabaleshwar"],
    ["26 Seater Tempo Traveller from Pune to Mahabaleshwar", "Pune to Panchgani Tempo Traveller"],
    ["Pune to Panchgani 17 Seater Tempo Traveller", "Pune to Mahabaleshwar 17 Seater Tempo Traveller"],
    ["Pune to Mahabaleshwar Mini Bus on Rent", "Pune to Mahabaleshwar Travel Package"],
    ["Pune to Mahabaleshwar Package 1 Day", "Pune to Mahabaleshwar Tour Package 3 Days"],
    ["Pune to Mahabaleshwar Mini Bus Packages", "Pune to Mahabaleshwar 14, 17, 25, 32 Seater Tempo Traveller"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Pune to Mahabaleshwar Tempo Traveller",
        "WhyChoosedescription": "Mauli Cabs offers spacious and comfortable Tempo Travellers for your trip from Pune to Mahabaleshwar. Whether it's a family vacation, a weekend getaway, or a group tour, our Tempo Travellers ensure a smooth and enjoyable journey."
    },
    {
        "WhyChooseheading": "Ideal for Group Travel to Mahabaleshwar",
        "WhyChoosedescription": "Our Tempo Travellers can accommodate large groups, providing ample seating, air-conditioning, and space for luggage. Enjoy a comfortable and stress-free ride as you travel from Pune to the scenic hill station of Mahabaleshwar."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive pricing for your Pune to Mahabaleshwar Tempo Traveller rental. With no hidden fees, you can enjoy an affordable journey without surprises, making it a perfect choice for group travel."
    },
    {
        "WhyChooseheading": "Experienced Drivers for a Safe Trip",
        "WhyChoosedescription": "Our experienced drivers are familiar with the Pune to Mahabaleshwar route and ensure your trip is safe, timely, and smooth. They prioritize passenger safety and comfort throughout the journey."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
        "WhyChoosedescription": "Mauli Cabs operates 24/7, offering you flexibility in booking your Tempo Traveller for any time of the day or night. Whether it's an early morning departure or a late-night return, we're here to serve you."
    },
    {
        "WhyChooseheading": "Instant Booking and Real-Time Tracking",
        "WhyChoosedescription": "Booking a Tempo Traveller for your Pune to Mahabaleshwar trip is quick and easy with Mauli Cabs. Book online via our website or app and track your ride in real-time for added convenience."
    },
    {
        "WhyChooseheading": "Safe, Sanitized, and Secure Travel Experience",
        "WhyChoosedescription": "We prioritize the safety and comfort of our passengers. All our Tempo Travellers are sanitized regularly, and our drivers adhere to hygiene and safety protocols, ensuring a secure and pleasant travel experience."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "Mauli Cabs offers multiple payment options for your Pune to Mahabaleshwar Tempo Traveller booking, including UPI, credit/debit cards, mobile wallets, or cash, providing you with a seamless booking experience."
    }
]


















    }

    const faqData = [
        {
            question: 'How can I book a Tempo Traveller for a trip from Pune to Mahabaleshwar?',
            answer: 'Booking a Tempo Traveller for your Pune to Mahabaleshwar trip is simple with Mauli Cabs. Just visit our website or mobile app, select "Tempo Traveller" from the vehicle options, enter your travel details (pickup and destination), and confirm your booking. Our customer support team is available to assist you anytime.',
        },
        {
            question: 'What is the seating capacity of the Tempo Traveller for Pune to Mahabaleshwar?',
            answer: 'The Tempo Traveller comes in various seating capacities, ranging from 12 to 17 seats, making it perfect for large groups or families traveling to Mahabaleshwar. It provides ample space for both passengers and luggage.',
        },
        {
            question: 'Is the fare for the Tempo Traveller fixed for the Pune to Mahabaleshwar trip?',
            answer: 'Yes, the fare for the Tempo Traveller from Pune to Mahabaleshwar is fixed. The price includes fuel, driver charges, tolls, taxes, and other necessary fees. The total fare will be displayed before confirming the booking, with no hidden charges.',
        },
        {
            question: 'Can I rent a Tempo Traveller for a round trip from Pune to Mahabaleshwar?',
            answer: 'Yes, you can rent a Tempo Traveller for a round-trip from Pune to Mahabaleshwar. The round-trip option is cost-effective, and we ensure your return journey is comfortable as well.',
        },
        {
            question: 'Is the Tempo Traveller service available 24/7 for Pune to Mahabaleshwar?',
            answer: 'Yes, Mauli Cabs offers Tempo Traveller services 24/7 for your Pune to Mahabaleshwar trip. Whether you’re planning an early morning or late-night departure, you can book the vehicle as per your preferred schedule.',
        },
        {
            question: 'Can I carry extra luggage in the Tempo Traveller for the Pune to Mahabaleshwar trip?',
            answer: 'Yes, the Tempo Traveller offers ample luggage space, making it ideal for carrying extra bags or bulky items. Whether it’s for a family vacation or a group trip, you will have sufficient room for luggage and passengers.',
        },
        {
            question: 'What are the benefits of renting a Tempo Traveller for a Pune to Mahabaleshwar trip?',
            answer: 'The Tempo Traveller provides a comfortable and spacious ride for your trip from Pune to Mahabaleshwar. With features like air conditioning, plush seating, and ample luggage space, it ensures a comfortable journey for groups or families. It’s the perfect choice for long-distance travel with a group.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sameer Patil",
            position: "Travel Enthusiast",
            text: "We rented a Tempo Traveller for our trip from Pune to Mahabaleshwar. The vehicle was clean, spacious, and comfortable for our group of 14. The driver was courteous, and the journey was smooth. It was an excellent choice for our family trip!",
            image: "/img/testimonial/testimonial-thumb-1-105.png",
        },
        {
            name: "Ms. Anjali Verma",
            position: "Tour Organizer",
            text: "I booked a Tempo Traveller for a group trip to Mahabaleshwar from Pune. The vehicle was ideal for our group, providing comfort and space for everyone. The service was great, and the trip was enjoyable. I would definitely recommend Mauli Cabs for any group travel!",
            image: "/img/testimonial/testimonial-thumb-1-106.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Mahabaleshwar Tempo Traveller",
        "description": "Rent 13 to 32 seater tempo travellers from Pune to Mahabaleshwar. Available for 1-3 day tour packages, ideal for family trips, group tours, and corporate events.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "250"
        },
        "offers": {
          "@type": "Offer",
          "url": "https://www.maulicabs.com/pune-to-mahabaleshwar-tempo-traveller",
          "priceCurrency": "INR",
          "price": "30",
          "priceValidUntil": "2025-12-31"
        }
      };
      
     
      


    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Mahabaleshwar Tempo Traveller | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book 13 to 32 seater tempo travellers from Pune to Mahabaleshwar for family trips, group tours, and corporate events. Tour packages available for 1-3 days."
        />
        <meta
          name="keywords"
          content="Pune to Mahabaleshwar tempo traveller, tempo traveller from Pune to Mahabaleshwar, Mahabaleshwar travel package, Mahabaleshwar tempo traveller, 17 seater tempo traveller, 26 seater tempo traveller, Mahabaleshwar mini bus on rent"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/136.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomahabaleshawar;